import { Spacing } from '@persona-id/design-tokens';
import { DateTime } from 'luxon';
import styled from 'styled-components';

import AttributeItem from 'dashboard/components/AttributeItem';
import { Account } from 'dashboard/models/account';
import { AccountType } from 'dashboard/models/account-type';
import { AccountInfoAttribute, ModuleAccountInfo } from 'dashboard/modules/AccountInfo/model';
import Card from 'design-system/components/Card';
import { DATE_AND_TIME_TZ_FORMAT } from 'lib/constants/luxonFormats';

export const InfoGrid = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${Spacing[6]};
`;

export interface AccountInfoProps {
  module: ModuleAccountInfo;
  account: Account;
  accountType: AccountType;
}

const AccountInfo = ({ account, accountType, module }: AccountInfoProps) => {
  return (
    <Card data-test={`module__account-info--${module.token}`}>
      <Card.Body>
        <Card.Title>Info</Card.Title>
        <InfoGrid>
          {module.attributes.map((attribute) => (
            <InfoAttributeItem
              key={`account-details-info__${attribute.replace(/-/g, '_')}`}
              account={account}
              accountType={accountType}
              attribute={attribute}
            />
          ))}
        </InfoGrid>
      </Card.Body>
    </Card>
  );
};

interface InfoAttributeItemProps {
  key: string;
  account: Account;
  accountType: AccountType;
  attribute: AccountInfoAttribute;
}

const InfoAttributeItem = ({ account, accountType, attribute, key }: InfoAttributeItemProps) => {
  let value = '';
  let title = '';
  let isRedacted = false;

  switch (attribute) {
    case 'account-type':
      title = 'Account Type';
      value = accountType.attributes.name;
      break;
    case 'account-id':
      title = 'Account ID';
      value = account.id;
      break;
    case 'reference-id':
      title = 'Reference ID';
      value = account.attributes['reference-id'] ?? '';
      isRedacted = !!account.attributes['redacted-at'];
      break;
    case 'created-at':
      title = 'Created at';
      if (account.attributes['created-at']) {
        value = DateTime.fromISO(account.attributes['created-at']).toFormat(
          DATE_AND_TIME_TZ_FORMAT,
        );
      }
      break;
    case 'updated-at':
      title = 'Updated at';
      if (account.attributes['updated-at']) {
        value = DateTime.fromISO(account.attributes['updated-at']).toFormat(
          DATE_AND_TIME_TZ_FORMAT,
        );
      }
      break;
  }
  return (
    <AttributeItem
      key={key}
      title={title}
      value={value}
      isRedacted={isRedacted}
      wordBreak='break-all'
      dataTest={key}
    />
  );
};

export default AccountInfo;
